import { configuratorProperty } from '../constants/configuratorConstants';

export default class CarDiff {
    constructor(parent) {
        this.parent = parent;
        this.data = parent.data;
        this.car = parent.car;
        this.compareAccessories = [];
    }

    hasObserved(section) {
        return !!this.parent?.navigation?.hasObserved(section);
    }

    check({ choiceType, choiceId, tempCar, conflictChain }) {
        const isDiffId = this.car.id !== tempCar.id;
        const isDiffColour = this.car.colour !== tempCar.colour;
        const isDiffTrim = this.car.trim !== tempCar.trim;
        const isDiffWheel = this.car.wheel() !== tempCar.wheel();
        const isDiffAccessories = !_.isEqual(this.car.accessories.filter((a) => a !== this.car.wheel()), tempCar.accessories.filter((a) => a !== tempCar.wheel()));

        const currentAccessories = this.car.accessories.filter((a) => a !== this.car.wheel() && !tempCar.accessories.includes(a)).map((a) => this.data.accessories[a]);
        const compareAccessories = tempCar.accessories.filter((a) => a !== tempCar.wheel() && !this.car.accessories.includes(a)).map((a) => this.data.accessories[a]);

        // Don't show conflict when changing id and colour trim and wheels are default
        const isIdChoice = choiceType === configuratorProperty.id;
        const isDefaultWheel = this.car.isDefaultWheel();
        const isDefaultColour = this.car.isDefaultColour();
        const isDefaultTrim = this.car.isDefaultTrim();
        const isIdChangeWithDefaultWheelColourTrim = isIdChoice
            && (!isDiffWheel || isDefaultWheel)
            && (!isDiffTrim || isDefaultTrim)
            && (!isDiffColour || isDefaultColour)
            && !isDiffAccessories;

        // Don't show conflict when only difference is an accessory colour change
        const oneAccessoryDifferent = currentAccessories.length === 1 && compareAccessories.length === 1;
        const isAccessoryColourDiff = oneAccessoryDifferent 
            && currentAccessories[0].colours 
            && Object.values(currentAccessories[0].colours).includes(compareAccessories[0].partNumber);

        // Don't show colour/trim conflict until both colour and trim have been viewed
        const isColourChoice = choiceType === configuratorProperty.colour;
        const isTrimChoice = choiceType === configuratorProperty.trim;
        const exteriorObserved = this.hasObserved('exterior');
        const interiorObserved = this.hasObserved('interior');
        const isColourTrimChangeButNotObservedColourTrimAndIdIsSame = ((isColourChoice && isDiffTrim) || (isTrimChoice && isDiffColour)) && (!exteriorObserved || !interiorObserved) && !isDiffId;
        const preventConflictModal = isIdChangeWithDefaultWheelColourTrim || isAccessoryColourDiff || isColourTrimChangeButNotObservedColourTrimAndIdIsSame;

        return {
            type: choiceType,
            id: choiceId,
            name: this.choiceName({ choiceType, choiceId }),
            cause: conflictChain[0],
            isDiffId,
            isDiffColour,
            isDiffTrim,
            isDiffWheel,
            isDiffAccessories,
            currentAccessories,
            compareAccessories,
            preventConflictModal,
        };
    }

    choiceName({ choiceType, choiceId }) {
        switch (choiceType) {
        case configuratorProperty.id:
            return this.data.carMap[choiceId]?.name;
        case configuratorProperty.colour:
            return this.data.colourMap[choiceId]?.name;
        case configuratorProperty.trim:
            return this.data.trimMap[choiceId]?.name;
        case configuratorProperty.accessories:
            return this.data.accessories[choiceId]?.description;
        default:
            return '';
        }
    }
}
